import React from 'react';
import { connect } from 'react-redux';
import PitchEntity from './PitchEntity'
import { getInterval } from './gameJson'
import OvertakeBall from '../Animations/Movements/OvertakeBall'
import { WalkSpeed, BrownianSpeed } from '../../components/Animations/Scenes/Constants'

class Manager extends PitchEntity {

    static propTypes = {
        convertToPitchPosition: React.PropTypes.func.isRequired,
        home: React.PropTypes.bool.isRequired,
        onSelect: React.PropTypes.func.isRequired,
        getPositionOnBench: React.PropTypes.func.isRequired,
        name: React.PropTypes.string.isRequired,
        selected: React.PropTypes.bool.isRequired,
        currentEvent: React.PropTypes.number.isRequired,
        gameSpeed: React.PropTypes.number.isRequired,
        getKeyPoints: React.PropTypes.func.isRequired
    }

    constructor(props) {
        super(props);

        this.CurrentPosition = this.props.getPositionOnBench(this);
        this.showTacticsChange = false;
        let keyPoints = this.props.getKeyPoints(this.props.home)
        this.BenchSlotPoint = keyPoints.benchSlots[0];
        this.ManagerPoint = keyPoints.managerPoint;
    }

    componentDidUpdate(prevProps, prevState){
        if(this.props.currentEvent != prevProps.currentEvent) {
            let event = window.Json.game[this.props.currentEvent-1];
            if(event != null && event.ZT != null && (event.ZT.team == 1 && this.props.home || event.ZT.team == 2 && !this.props.home)){
                this.playTacticsChangeAnimation(event.ZT.text);
            }
            else {
                if(Math.abs(this.props.currentEvent - prevProps.currentEvent) > 1) {
                    this.endTacticsChangeAnimation();
                    this.CurrentPosition = this.props.getPositionOnBench(this);
                    this.forceUpdate();
                }
            }
        }
    }

    playTacticsChangeAnimation(text){
        this.MoveToWithSpeed(this.props.gameSpeed, WalkSpeed, this.ManagerPoint)
            .then(() => this.startTacticsChangeAnimation(text))
            .then(() => this.BrownianMovement(this.props.gameSpeed, 140))
            .then(() => this.endTacticsChangeAnimation())
            .then(() => this.MoveToWithSpeed(this.props.gameSpeed, WalkSpeed, this.BenchSlotPoint))
    }

    startTacticsChangeAnimation(text) {
        this.showTacticsChange= true;
        if(text == null || text == "")
            text = "...";
        this.speech = text;
        this.forceUpdate();
    }
    
    endTacticsChangeAnimation() {
        this.showTacticsChange = false;
    }

    render() {
        
        if(this.CheckIfOutsidePitch())
            return null;
        
        var position = this.props.convertToPitchPosition(this.CurrentPosition, this.props.home);
        
        var diff = this.getPositionDiff();
        var top = position.Top - diff;
        var left = position.Left - diff;

        let isSelected = this.props.selected;

        const managerShapeStyle = {
            background: this.props.shirtBackground,
            color: this.props.shirtTextColor,
            borderColor: this.props.shirtBorderColor
          };


        return (<div style={{ top: top + 'px', left: left + 'px', zIndex: 3, opacity: this.opacity }} className={this.getContainerClass()}>
                    <div onClick={event => this.props.onSelect(this.props.home, !isSelected)} style={managerShapeStyle} className={this.props.home ? "manager_shape home" : "manager_shape away"}>
                        <div className="player_number">M</div>
                        {this.showTacticsChange === true &&
                            <p style={{ width: (this.speech.length > 3 ? this.speech.length*7 : 30) + 'px'}} className="speech">{this.speech}</p>
                        }
                    </div>
                    {(isSelected === true || this.showTacticsChange === true) &&
                        <span className="player_name">{this.props.name}</span>
                    }
                    
                </div>)
    }
    
}

export default Manager


/** WEBPACK FOOTER **
 ** ./src/components/Pitch/Manager.js
 **/